import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {SampleDescriptor} from '../util/getSampleDescriptor';

/**
 * Optionally creates a message to be shown to the user if:
 *   - The table they're inserting into does not allow new rows to be added, and
 *   - The user has selected too many samples from the source table (i.e., it would require new rows)
 *
 *  Note that this is a function, not a component, so that it can return NULL to indicate "no message."
 */

interface NonExpansionFooterMessage {
  numberOfSelectedSamples: number;
  maximumNumberOfSamplesBeforeExpansion: number;
  preventTableExpansionMessage: string;
  sampleDescriptor: SampleDescriptor;
}

export default function nonExpansionFooterMessage(props: NonExpansionFooterMessage): JSX.Element | null {
  const {maximumNumberOfSamplesBeforeExpansion: maxSamples, sampleDescriptor} = props;
  if (props.numberOfSelectedSamples > maxSamples) {
    return (
      <div className={css(styles.footerText)}>
        {props.preventTableExpansionMessage}
        {maxSamples > 0 && (
          <>
            <br />
            You can add at most {maxSamples}{' '}
            {maxSamples > 1 ? sampleDescriptor.plural : sampleDescriptor.singular} to it.
          </>
        )}
      </div>
    );
  }
  return null;
}

const styles = StyleSheet.create({
  footerText: {
    height: '36px', // To match the submit button in modal footer
    verticalAlign: 'middle',
    display: 'table-cell',
    textAlign: 'left',
  },
});
